// extracted by mini-css-extract-plugin
export default {"paye-header":"Header_paye-header__SbL1G","paye-header__buttons":"Header_paye-header__buttons__h6y-m"};